import React from 'react';
import Navigation from '../components/navigation';
import { Hero } from '../components/hero';
import { ServicesOverview } from '../components/servicesoverview';
import { WhyChooseUs } from '../components/whychooseus';
import { StatsSection } from '../components/statssection';
import { FAQSection } from '../components/faqsection';
import { Testimonials } from '../components/testimonials';
import { Footer } from '../components/footer';
import { CommercialShowcase } from '../components/commercialshowcase';
import { useAudience } from '../context/audiencecontext';

const Home = () => {
  const { isCommercial } = useAudience();

  return (
    <div className="min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <ServicesOverview />
        {isCommercial && <CommercialShowcase />}
        <WhyChooseUs />
        <StatsSection />
        <FAQSection />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
